module.exports = __webpack_public_path__ + "static/media/logFlowRateActive.15219881.svg";